export default [
  {
    name: 'live-monitoring',
    path: '/monitoring/live',
    component: () => import('@/views/monitoring/Monitoring')
  },
  {
    name: 'live-sensor-monitoring',
    path: '/monitoring/sensors/live',
    component: () => import('@/views/sensors/monitoring/LiveSensorMonitoring')
  },
  {
    name: 'live-event-monitoring',
    path: '/monitoring/events/live',
    component: () => import('@/views/events/monitoring/LiveEventMonitoring')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeMonitoring.js